import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, CircularProgress } from '@mui/material';
import useFeedbackCall from '../../hooks/useFeedbackCall';
import { location } from '../../helper/data';
import { department } from "../../helper/data"
import Checkbox from '@mui/material/Checkbox';
import { validateContactFields } from '../../helper/contactValidation';

// Ramak Kala tam ad ve e-postayı zorunlu, telefonu ise girildiğinde doğrular.
const CONTACT_RULES = {
  name: { type: "fullName", label: "Ad soyad", required: true },
  phone: { type: "phone", label: "Telefon", required: false },
  email: { type: "email", label: "E-posta", required: true },
}

const RamakKala_View = ({ loading }) => {

  const { postFireData } = useFeedbackCall()

  const now = new Date()

  // Gün, Ay ve Yıl için değerleri al
  const day = String(now.getDate()).padStart(2, '0'); // Günü 2 basamaklı yap
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Ayı 2 basamaklı yap (0'dan başladığı için +1 ekliyoruz)
  const year = now.getFullYear();

  // Saat, Dakika ve Saniye için değerleri al
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  // Düzenlenmiş tarih ve saati birleştir
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

  const [bonnaUser, setBonnaUser] = useState(false)

  const [info, setInfo] = useState({
    name: "",
    phone: "",
    email: "",
    gorev: "",
    topic: "Tehlikeli Durum & Ramak Kala",
    eventType: "",
    birim: "",
    location: "",
    yerZaman: "",
    ramakkaladetay: "",
    oneri: "",
    actionType: "",
    actionResult: "",
    bonnaUser: bonnaUser ? 'Bonna Çalışanı' : 'Misafir',
    datetime: formattedDate
  })
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    setInfo(prevInfo => ({ ...prevInfo, [name]: value }))
    setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }))
  }

  const handleContactBlur = (e) => {
    const { name } = e.target
    if (!CONTACT_RULES[name]) return

    const validation = validateContactFields(info, { [name]: CONTACT_RULES[name] })
    setErrors(prevErrors => ({ ...prevErrors, [name]: validation.errors[name] }))
  }

  const handleIsCheck = (e) => {
    const { checked } = e.target
    checked ? setBonnaUser(true) : setBonnaUser(false)
  }

  const handleSubmit = (e) => {

    e.preventDefault()

    const validation = validateContactFields(info, CONTACT_RULES)
    if (!validation.isValid) {
      setErrors(validation.errors)
      e.currentTarget.elements.namedItem(Object.keys(validation.errors)[0])?.focus()
      return
    }

    setErrors({})
    postFireData('ramakkala', validation.values)

    setInfo({
      name: "",
      phone: "",
      email: "",
      gorev: "",
      topic: "Tehlikeli Durum & Ramak Kala",
      eventType: "",
      birim: "",
      location: "",
      yerZaman: "",
      ramakkaladetay: "",
      oneri: "",
      actionType: "",
      actionResult: "",
      bonnaUser: bonnaUser ? 'Bonna Çalışanı' : 'Misafir',
      datetime: formattedDate
    })

  }


  return (
    <div>

      <Typography align='center' color='#FFB534' p={3} fontWeight={700} fontSize={22}>Tehlikeli Durum & Ramak Kala</Typography>

      <Typography variant='subtitle2' align='center' color={'error'}>
      Geri bildirimlerinizin takibi ve durumunu öğrenmek için telefon numarası ve mail adresinizin doğruluğu önemlidir !
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 5, p: 2 }}>

        <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '800px' }}>

          <Box sx={{ flexDirection: 'column', display: 'flex', gap: 3, p: 3 }}>

            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
              <TextField
                fullWidth
                required
                label='Adı soyadı'
                name='name'
                id='name'
                type='text'
                value={info.name}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.name}
                helperText={errors.name}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
              <TextField
                fullWidth
                label='Telefon (0xxx-xxx-xxxx)'
                name='phone'
                id='phone'
                type='tel'
                value={info.phone}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.phone}
                helperText={errors.phone}
              />
              <TextField
                fullWidth
                required
                label='E-posta'
                name='email'
                id='email'
                type='email'
                value={info.email}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>


            <Box>
              <FormControlLabel
                control={
                  <Checkbox onChange={handleIsCheck} name="gilad" />
                }
                label="Bonna Çalışanı mısın ?"
              />
            </Box>

            {/* bonna çalışanı ise burayı göster */}
            {
              bonnaUser &&
              (
                <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3, border: '1px solid #7487daed', borderRadius: 3, p: 2 }}>
                  <TextField
                    fullWidth
                    label='Görev'
                    name='gorev'
                    id='gorev'
                    type='text'
                    value={info.gorev}
                    // inputProps={{
                    //   maxLength: 35
                    // }}
                    onChange={handleChange}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="birim">Departman</InputLabel>
                    <Select
                      required
                      labelId='birim'
                      name='birim'
                      id='birim'
                      label='birim'
                      value={info.birim}
                      onChange={handleChange}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            overflow: 'auto'
                          }
                        }
                      }}
                    >
                      {
                        department.map((item, index) => (
                          <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="location">Lokasyon</InputLabel>
                    <Select
                      required
                      labelId='location'
                      name='location'
                      id='location'
                      label='location'
                      value={info.location}
                      onChange={handleChange}
                    >
                      {
                        location.map((item, index) => (
                          <MenuItem key={index} value={item}>{item}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Box>
              )
            }

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

              <FormControl fullWidth required>
                <InputLabel id="eventType">Tehlikeli Durum / Ramak Kala</InputLabel>
                <Select
                  labelId='eventType'
                  name='eventType'
                  id='eventType'
                  label='Tehlikeli Durum / Ramak Kala'
                  value={info.eventType}
                  onChange={handleChange}
                >
                  <MenuItem value="Tehlikeli Durum">Tehlikeli Durum</MenuItem>
                  <MenuItem value="Ramak Kala">Ramak Kala</MenuItem>
                </Select>
              </FormControl>

              <TextField
                fullWidth
                required
                label='Yeri / Zamanı'
                name='yerZaman'
                id='yerZaman'
                type='text'
                value={info.yerZaman}
                onChange={handleChange}
              />

              <TextField
                fullWidth
                required
                multiline
                rows={4}
                label='Tehlikeli Durum / Ramak Kala Olayı Anlatınız'
                name='ramakkaladetay'
                id='ramakkaladetay'
                type='text'
                value={info.ramakkaladetay}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                multiline
                rows={4}
                label='İyileştirme Öneriniz'
                name='oneri'
                id='oneri'
                type='text'
                value={info.oneri}
                onChange={handleChange}
              />
            </Box>

            {
              loading ?
                <CircularProgress size={20} color="inherit" />
                :

                <Button disabled={loading} variant='contained' type='submit' sx={{ letterSpacing: 3, textTransform: 'none' }}>
                  Kayıt
                </Button>
            }

          </Box>

        </form>

      </Box>

    </div>
  )
}

export default RamakKala_View